<template>
  <div class="content">
    <form>
      <kirim-form :datas="dataall"></kirim-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.prixod.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { KirimForm, Kontragent, Sklad, Firma, Paytype } from "@/pages";
export default {
  components: {
    KirimForm,
    Kontragent,
    Sklad,
    Firma,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$root.$refs.prixod.SaveSettings();
    if (this.$store.state.saved < 2) {
      this.$store.state.saved = null;
      localStorage.removeItem("prostatka");
      next();
      this.$store.state.selected_index = null;
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  data() {
    return {
      watch: false,
      update_password: "",
      dataall: {}
    };
  },
  methods: {
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Кирим" });
      },
    Data() {
      let self = this;
      axios
        .get("api/v1/prixod/id/" + self.$route.params.id)
        .then(function(response) {
          const data = response.data;
          // Tannarx valyutasini saqlangan qatorlardan tiklaymiz.
          // Bazada eski konvensiya: prixod_table.cost_currency 1 = so'm, 3 (yoki 2) = dollar.
          // Formada esa 1 = so'm, 2 = dollar. Qator bo'lmasa yoki bo'sh bo'lsa — so'm.
          const rows = Array.isArray(data.prixod_table) ? data.prixod_table : [];
          const anyDollar = rows.some(function (r) {
            const c = parseInt(r && r.cost_currency);
            return c === 2 || c === 3;
          });
          data.cost_currency = anyDollar ? 2 : 1;
          self.dataall = data;
          // self.dataall.created_at=new Date(response.data.created_at * 1000).toISOString().substr(0, 16);
          setTimeout(() => {
            self.watch = true;
          }, 100);
        });
    },
    Sklad() {
      let self = this;
      axios
        .get("api/v1/sklads/id/" + localStorage.getItem("sklad_id"))
        .then(function(response) {
          self.update_password = response.data.update_password;
        });
    }
  },
  created: function() {
    this.Data();
    this.Sklad();
  }
};
</script>
